module.exports = require('./Vue2BootstrapModal.vue')
